<h2 mat-dialog-title>Describing your Event</h2>
<mat-dialog-content class="mat-typography">
  <p>A strong and clear event description excites attendees: tell them what will happen at the event, who will be
    speaking, and what they might get out of attending. Your event may be brilliant, but no one else will know without
    you telling and convincing them.</p>
  <h3>Write in the third person</h3>
  <p>When writing an event description it is import to write it from the perspective of the potential attendee.</p>
  <div class="examples">
    <div class="bad example">
      <span class="icon">
        <fa name="times"></fa>
      </span>
      <p>In four months time we are going to have the BEST FESTIVAL EVER!!! Starts at 10 am across from the corner shop,
        the O-Connor Family will get the party started.</p>

    </div>
    <div class="good example">
      <span class="icon">
        <fa name="check"></fa>
      </span>
      <p>From 13 May to 16 May, the city will celebrate it's Viking hertigate. Beginning at 10:00 each day, the Main
        Street will see local bands and international acts take to the festival stage. With walking tours, a funfair,
        street performers and art exhibitions, there are event for all ages.</p>

    </div>
  </div>

  <h3>Put the tastiest bits upfront in the teaser</h3>
  <p>Include the most interesting and most important information in the teaser as this becomes the first paragraph on your event’s web listing. It is read first and needs to engage people quickly.</p>

  <h3>Do not over generalise</h3>
  <p>Don’t be tempted by a wide ranging description of topics and activities to over-generalise just provide attendees
    with enough information to tempt them.</p>
  <div class="examples">
    <div class="bad example">
      <span class="icon">
        <fa name="times"></fa>
      </span>
      <p>An exciting celebration of all things science, if you like science then this is the event for you! </p>

    </div>
    <div class="good example">
      <span class="icon">
        <fa name="check"></fa>
      </span>
      <p>Working scientists talk about the science that has inspired them, such as the discovery of the Wollemi pine.</p>
    </div>
  </div>


</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="footer">
    <button mat-button mat-dialog-close type="button">Got it!</button>
  </div>
</mat-dialog-actions>